import { useEffect } from 'react';
import { useUbicacionesUsuarioContext } from '../contexts/UbicacionesUsuarioContext';

export interface UseAutoUbicacionPredeterminadaOptions {
  nroUbicacionDestino?: number | null;
  onApply: (nroUbicacion: number, nombreUbicacion: string) => void;
  /** Si es false, no se aplica la ubicación predeterminada (p. ej. mientras carga un documento origen). */
  enabled?: boolean;
}

/**
 * Completa automáticamente la ubicación destino con la predeterminada del usuario logueado
 * cuando el formulario aún no tiene una asignada.
 */
export function useAutoUbicacionPredeterminada({
  nroUbicacionDestino,
  onApply,
  enabled = true,
}: UseAutoUbicacionPredeterminadaOptions): void {
  const { preferidaUbicacion, loading } = useUbicacionesUsuarioContext();

  useEffect(() => {
    if (!enabled || loading) return;
    const nro = nroUbicacionDestino ?? 0;
    if (nro > 0) return;
    if (!preferidaUbicacion) return;
    const nombre =
      (preferidaUbicacion.nombreUbicacion ?? '').trim() ||
      `Ubicación ${preferidaUbicacion.nroUbicacion}`;
    onApply(preferidaUbicacion.nroUbicacion, nombre);
  }, [enabled, loading, nroUbicacionDestino, preferidaUbicacion, onApply]);
}
